<template>
    <div class="main">
        <my_menu active_name="2-0" :open_active="['2']"></my_menu>
        <div class="content">


            <div class="rili_div" v-if="pass_list">
                <Calendar hide-type @on-cell-click='cell_click' @on-cell-contextmenu="cell_contextmenu">
                    <template #month="{ date, data }">
                        <div>
                            <Badge status="success" text=" >_<" v-if="pass_list.indexOf(data.day) != -1" />
                        </div>
                    </template>
                </Calendar>
            </div>
        </div>
    </div>
</template>

<script>
import my_menu from '@/component/admin/menu/menu.vue'

import { http } from "@/utils/http.js";
import { TablePaste } from 'view-ui-plus';

export default {
    components: {
        my_menu
    },
    data() {
        return {

            pass_list: null
        }
    },
    mounted() {
        this.get_pass_day_list()
    },
    methods: {
        cell_contextmenu(e) {
            // this.$Message.error('取消' + e.text)
            var that = this
            var obj = {
                day_text: e.text
            }
            http("post", process.env.VUE_APP_HOST + "/ak/del_day", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        console.log(res.data)
                        that.get_pass_day_list()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },
        cell_click(e) {
            console.log(e)
            // this.$Message.info('添加' + e.text)
            var that = this
            var obj = {
                day_text: e.text
            }
            http("post", process.env.VUE_APP_HOST + "/ak/add_day", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.info({
                            content: res.msg,
                            duration: 3,
                        });
                        console.log(res.data)
                        that.get_pass_day_list()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },
        get_pass_day_list() {

            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/ak/get_pass_day_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {

                        console.log(res.data)
                        that.pass_list = res.data.pass_day_list
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })


        }
    }
}
</script>


<style scoped>
.content {
    overflow: auto;
    padding: 10px;
    width: calc(100% - 220px);
    background-color: #fff;
    position: absolute;
    right: 10px;
    top: 10px;
    height: calc(100vh - 20px);
    border-radius: 5px;
}

.main {
    background: #ececec;
    min-height: 100vh;
}

.rili_div {
    padding: 5px 20px;
}
</style>